const BASE_RECORDING_ROUTE = '/api/rest/recording'

export const dataTestIdPrefix = 'App-Recordings-MediaPlayer-Evaluation-'

export const activeEvalFormsUrl = `${BASE_RECORDING_ROUTE}/evalform?status=1&exclude=sections`
export const evalFormGroupsUrl = `${BASE_RECORDING_ROUTE}/evalformgroup`

export interface EvalFormBandRegion {
  band: number,
  begin: number,
  end: number,
}

export interface EvalFormResponseType {
  id: number,
  name: string,
}

export interface EvalFormQuestionOption {
  id: number,
  type: string,
  label: string,
  isDefault: boolean,
  kpiPriority: number,
  order: number,
  points: number,
  displaySection: number,
  displayQuestion: number,
}

export interface EvalFormQuestion {
  id: number,
  text: string,
  description: string,
  weight: number,
  options: EvalFormQuestionOption[],
  order: number,
  displayOnLoad: boolean,
}

export interface EvalFormSection {
  id: number,
  name: string,
  weight: number,
  startColor: string,
  endColor: string,
  questions: EvalFormQuestion[],
  order: number,
  displayOnLoad: boolean,
}

export interface EvalFormScoreType {
  id: number,
  name: string,
}

export interface EvalForm {
  id: number,
  name: string,
  description: string,
  creator: string,
  created: number,
  createdTz: string,
  manualWeighting: boolean,
  updater: string,
  updated: number,
  updatedTz: string,
  status: number,
  defaultForm: boolean,
  approvalRequired: boolean,
  bandRanges: EvalFormBandRegion[],
  scoreType: EvalFormScoreType,
  responseType: EvalFormResponseType,
  hasBranchingLogic: boolean,
  sections: EvalFormSection[],
}

